import { Outlet } from "react-router-dom"

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className=" min-h-screen md:mx-auto md:max-w-md px-4 py-10">
        <Outlet />
      </main>
    </div>
  )
}
